import React from 'react';
import { A } from 'hookrouter';

const DisplayItem = ({ item }) => {
    if (!item.link || !item.link.length) {
        return <div title={item.detailedName}>{item.name}</div>;
    }
    return (
        <A className='text-primary d-block' title={item.detailedName} href={item.link}>
            {item.name}
        </A>
    );
};

export default DisplayItem;
